import useAuthRequest from "../request/useAuthRequest";
import colleagueRequest from "../../rest/request/account/colleagueRequest";
import {useMemo} from "react";
import {request} from "../../../../res/rest/restRequest";
import axios from "axios";
import {api} from "../../../../res/rest/api";
import {env} from "../../../../res/config/env";

const useColleagues = () => {

    const {
        session,
        loading,
        error,
        result,
        sendIt
    } = useAuthRequest();
    const {
        loading: updating,
        error: updateError,
        sendIt: updateIt
    } = useAuthRequest();

    const loadUsers = () => {
        const req = colleagueRequest();
        sendIt(req.sendIt);
    }

    if(session.isSignedIn && !loading && !error && !result) {
        loadUsers();
    }

    const interestAreas = useMemo(() => {
        if(!result?.interestAreas) {
            return {};
        }

        const map = {};
        result.interestAreas.forEach((area) => map[area.id] = area);
        return map;
    }, [result?.interestAreas]);

    const updateUser = (user, toUpdate) => {
        const req = request.model("ad_user").id(user.id)
        const update = (s) => axios.put(req.buildRequest(env.API_URL), toUpdate, api.auth(s))
        updateIt(update, loadUsers);
    }

    return {
        loading,
        error,
        colleagues: result?.users,
        interestAreas,
        updateUser,
        updateError,
        updating
    }

}

export default useColleagues;